import { render, staticRenderFns } from "./PersonneCard.vue?vue&type=template&id=08237f0c&scoped=true&"
import script from "./PersonneCard.vue?vue&type=script&lang=js&"
export * from "./PersonneCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonneCard.vue?vue&type=style&index=0&id=08237f0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08237f0c",
  null
  
)

export default component.exports